// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"d14b0a20","977":"4b93f112"}[chunkId] + ".chunk.js";
};